// extracted by mini-css-extract-plugin
module.exports = {"chosenCategoryGrid":"ChosenCategoryGrid_chosenCategoryGrid__1CyYG","ViewedSectionSecondary__3videos":"ChosenCategoryGrid_ViewedSectionSecondary__3videos__tipuF"};